import React, { useEffect, useState } from "react";

// Utility to group and summarize
// const groupAndSummarize = (data, groupKey) => {
//   const grouped = {};
//   data.forEach(row => {
//     const key = row[groupKey];
//     if (!grouped[key]) {
//       grouped[key] = { ...row, count: 0 };
//       grouped[key].productOpeningPrice = 0;
//       grouped[key].productLiftingPrice = 0;
//       grouped[key].productIMSPrice = 0;
//       grouped[key].productClosingPrice = 0;
//       grouped[key].productDMGPrice = 0;
//       grouped[key].productNetPrice = 0;
//     }
//     grouped[key].productOpeningPrice += row.productOpeningPrice || 0;
//     grouped[key].productLiftingPrice += row.productLiftingPrice || 0;
//     grouped[key].productIMSPrice += row.productIMSPrice || 0;
//     grouped[key].productClosingPrice += row.productClosingPrice || 0;
//     grouped[key].productDMGPrice += row.productDMGPrice || 0;
//     grouped[key].productNetPrice += row.productNetPrice || 0;
//     grouped[key].count++;
//   });

//   return Object.entries(grouped).map(([key, value]) => ({
//     name: key,
//     data: value,
//     level: groupKey,
//   }));
// };

const groupAndSummarize = (data, groupKey) => {
  const grouped = {};

  data.forEach(row => {
    const key = row[groupKey];
    if (!grouped[key]) {
      grouped[key] = {
        ...row,
        count: 0,
        productOpeningPrice: 0,
        productLiftingPrice: 0,
        productIMSPrice: 0,
        productClosingPrice: 0,
        productDMGPrice: 0,
        productNetPrice: 0
      };
    }

    grouped[key].productOpeningPrice += row.productOpeningPrice || 0;
    grouped[key].productLiftingPrice += row.productLiftingPrice || 0;
    grouped[key].productIMSPrice += row.productIMSPrice || 0;
    grouped[key].productClosingPrice += row.productClosingPrice || 0;
    grouped[key].productDMGPrice += row.productDMGPrice || 0;
    grouped[key].productNetPrice += row.productNetPrice || 0;
    grouped[key].count++;
  });

  return Object.entries(grouped).map(([key, value]) => ({
    name: key,
    data: value,
    level: groupKey,
  }));
};

const getEmployeeName = (list, level, id) => {
  const match = list.find(emp => emp[level] === id);
  return match ? match.empName : '';
};



const ProductStockTable = ({ productStockDataViews, nsmList, dsmList, asmList, tsmList }) => {
  const [groupedData, setGroupedData] = useState([]);

useEffect(() => {
  if (!Array.isArray(productStockDataViews)) return;

  const zoneGroups = groupAndSummarize(productStockDataViews, "zoneName");
  const divisionGroups = groupAndSummarize(productStockDataViews, "divisionName");
  const regionGroups = groupAndSummarize(productStockDataViews, "regionName");
  const territoryGroups = groupAndSummarize(productStockDataViews, "territoryName");

  const final = [];

  zoneGroups.forEach(zone => {
    const nsm = nsmList.find(x => x.zoneId === zone.data.zoneID);

    final.push({ 
      ...zone, 
      levelType: "zone", 
      empId: nsm?.empId, 
      empName: nsm?.empName, 
      roleName: nsm?.roleName, 
      allocatedSim: nsm?.allocatedSim,
      jobDuration: nsm?.jobDuration 
    });

    const divisionsInZone = divisionGroups.filter(d => d.data.zoneName === zone.name);

    divisionsInZone.forEach(division => {
      const dsm = dsmList.find(x => x.divisionId === division.data.divisionID && x.zoneId === zone.data.zoneID);

      final.push({ 
        ...division, 
        levelType: "division", 
        empId: dsm?.empId, 
        empName: dsm?.empName, 
        roleName: dsm?.roleName, 
        allocatedSim: dsm?.allocatedSim,
        jobDuration: dsm?.jobDuration 
      });

      const regionsInDivision = regionGroups.filter(r => r.data.divisionName === division.name);

      regionsInDivision.forEach(region => {
        const asm = asmList.find(x => x.regionId === region.data.areaId && x.divisionId === division.data.divisionID);

        final.push({ 
          ...region, 
          levelType: "region", 
          empId: asm?.empId, 
          empName: asm?.empName, 
          roleName: asm?.roleName, 
          allocatedSim: asm?.allocatedSim,
          jobDuration: asm?.jobDuration 
        });

        const territoriesInRegion = territoryGroups.filter(t => t.data.regionName === region.name);

        territoriesInRegion.forEach(territory => {
          const tsm = tsmList.find(x => x.territoryId === territory.data.territoryId && x.regionId === region.data.areaId);

          final.push({ 
            ...territory, 
            levelType: "territory", 
            empId: tsm?.empId, 
            empName: tsm?.empName, 
            roleName: tsm?.roleName, 
            allocatedSim: tsm?.allocatedSim,
            jobDuration: tsm?.jobDuration 
          });
        });
      });
    });
  });

  setGroupedData(final);
}, [productStockDataViews, nsmList, dsmList, asmList, tsmList]);

  const getBgColor = (levelType) => {
    switch (levelType) {
      case "zone": return "#ffe699";
      case "division": return "#92d050";
      case "region": return "#f4b084";
      case "territory": return ""; // no bg for leaf level
      default: return "";
    }
  };

  return (
    <table  className="table table-bordered table-xs">
      <thead className="thead-light sticky-header  text-center head-font-size">
        <tr>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#ffff00' }}>Location</th>
          <th  className="sticky-header border align-middle p-2">Role</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor:'#8db5e3'}}>Enroll</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#e36b09' }}>Employee</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor:'#8db5e6'}}>Mobile</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#cbbfd9' }}>Opening Value</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#fce9d9' }}>Lifting Value</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#92d14f' }}>IMS Value</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#e36b09' }}>Closing Value</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#dedac5' }}>Damage Value</th>
          <th  className="sticky-header border align-middle p-2" style={{ backgroundColor: '#ffff00' }}>Net Stock Value</th>
        </tr>
      </thead>
      <tbody>
        {/* {groupedData.map((row, index) => {
          const d = row.data;
          return (
            <tr key={index} style={{ backgroundColor: getBgColor(row.levelType), fontWeight: row.levelType !== "territory" ? "bold" : "normal" }}>
              <td>{row.name}</td>
              <td className="text-right">{Math.round(d.productOpeningPrice)}</td>
              <td className="text-right">{Math.round(d.productLiftingPrice)}</td>
              <td className="text-right">{Math.round(d.productIMSPrice)}</td>
              <td className="text-right">{Math.round(d.productClosingPrice)}</td>
              <td className="text-right">{Math.round(d.productDMGPrice)}</td>
              <td className="text-right">{Math.round(d.productNetPrice)}</td>
            </tr>
          );
        })} */}

        {groupedData.map((row, index) => {
          const d = row.data;
          return (
            <tr key={index} style={{
              backgroundColor: getBgColor(row.levelType),
              fontWeight: row.levelType !== "territory" ? "bold" : "normal"
            }}>
              <td>{row.name}</td>
              <td>{row.roleName || "-"}</td>
              <td>{row.empId || "-"}</td>
              <td>{row.empName || '-'}</td>
              <td>{row.allocatedSim || "-"}</td>
              <td className="text-right">{Math.round(d.productOpeningPrice)}</td>
              <td className="text-right">{Math.round(d.productLiftingPrice)}</td>
              <td className="text-right">{Math.round(d.productIMSPrice)}</td>
              <td className="text-right">{Math.round(d.productClosingPrice)}</td>
              <td className="text-right">{Math.round(d.productDMGPrice)}</td>
              <td className="text-right">{Math.round(d.productNetPrice)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ProductStockTable;



